import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import User from '../../../bower_components/teknisavuecomponents/assets/interfaces/User';
import Periodo from '../../../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import DefaultScreenContent from '@/components/DefaultScreenContent.vue';
import CrudGrid from '../../../bower_components/teknisavuecomponents/components/grids/CrudGrid.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import ConfirmationDialog from '../../../bower_components/teknisavuecomponents/components/popups/ConfirmationDialog.vue';
import ControleEntregaEPIPopup from '@/components/ControleEntregaEPIPopup/ControleEntregaEPIPopup.vue';
import ControleEntregaEPIController from '@/assets/ts/controller/ControleEntregaEPIController';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'ControleEntregaEPI',
  components: {
    DefaultScreenContent,
    CrudGrid,
    ConfirmationDialog,
    TkVisualizer,
    ControleEntregaEPIPopup,
  },
})
class ControleEntregaEPI extends Vue {
  // #region [ STORE ]
  @Getter('user')
  private user: User;

  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  @Mutation('changeCurrentView')
  private changeCurrentView: (viewTitlw: string) => void;
  // #endregion

  // #region [ DATA ]
  private loading = false;

  private view = {
    title: 'Controle de Entrega de EPI',
    popUpTitle: 'Controle de Entrega de EPI',
  };

  private fieldsData = {
    NMEPI: [],
  };

  private grid = {
    name: this.view.popUpTitle,
    messages: {
      loadingText: 'Carregando Histórico de EPI...',
      noDataText: 'Nenhum Histórico de EPI Encontrado.'
    },
    triggers: {
      reload: 0,
    },
    dataSource: {
      route: 'getControleEntregaEPI',
      filters: {
        NRORG: this.$store.state.user.nrorg,
        NRESTRUTURAM: this.$store.state.estruturaGerencialAtual.NRESTRUTURAM,
        NRPERIODOAPURACAO: this.$store.state.periodoDemonstrativoAtual.NRPERIODOAPURACAO,
      }
    },
    actions: [
      'view',
      {
        name: 'Editar',
        value: 'save',
        icon: 'mdi-pencil',
        action: ControleAcessoWrapper.atualizar(this.controleEntregaEPIPopup),
        mode: 'view',
      },
      {
        name: 'Excluir',
        value: 'exclude',
        icon: 'mdi-delete',
        action: ControleAcessoWrapper.deletar(this.removeEntregaEPIPopup),
        mode: 'view',
      },
    ],
    toolbarActions: [
      'reload',
      {
        name: 'add',
        label: 'Adicionar',
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.controleEntregaEPIPopup),
      }
    ],
  };

  private get gridColumns() {
    return [
      {
        text: 'Vínculo',
        value: 'NMVINCULOM',
        name: 'NMVINCULOM',
        tag: 'v-text-field',
        cols: 7,
        required: true,
        showOnList: true,
      },
      {
        text: 'EPI',
        value: 'NMEPI',
        name: 'NMEPI',
        tag: 'v-text-field',
        cols: 6,
        required: true,
        showOnList: true,
      },
      {
        text: 'Qtd. Fornecida',
        value: 'QTFORNECIDAEPI',
        name: 'Qtd. Fornecida',
        type: 'number',
        tag: 'v-text-field',
        cols: 6,
        showOnList: true,
      },
      {
        text: 'Fornecedor',
        value: 'NMPRINCIPALPARC',
        name: 'NMPRINCIPALPARC',
        type: 'text',
        tag: 'v-text-field',
        cols: 6
      },
      {
        text: 'Certificado de Aprovação',
        value: 'NRCTRLAPROVEPI',
        type: 'text',
        tag: 'v-text-field',
        cols: 6,
        showOnList: true,
      },
      {
        text: 'Modelo',
        value: 'DSMODELOEPI',
        type: 'text',
        tag: 'v-text-field',
        cols: 3,
        showOnList: true,
      },
      {
        text: 'Proteção Eficaz',
        value: 'DSPROTECAOEFICAZ',
        valueField: 'IDPROTECAOEFICAZ',
        descriptionField: "DSPROTECAOEFICAZ",
        readonly: true,
        type: 'text',
        tag: 'v-text-field',
        cols: 3,
      },
      {
        text: 'Controle Entrega',
        value: 'IDCTRLENTREGA',
        type: 'text',
        tag: 'v-text-field',
        cols: 6,
        showOnList: true,
      },
      {
        text: 'Entrega Progr.',
        value: 'DTENTREGAEPI',
        type: 'text',
        tag: 'TkDate',
        cols: 3,
        showOnList: false,
      },
      {
        text: 'Entrega Efetiva',
        value: 'DTEFETIVA',
        type: 'text',
        tag: 'TkDate',
        cols: 3,
        showOnList: false,
      },
      {
        text: 'Motivo Devolução',
        value: 'NMMOTIVODEVEPI',
        valueField: 'NRMOTIVODEVEPI',
        descriptionField: 'NMMOTIVODEVEPI',
        readonly: true,
        type: 'text',
        tag: 'v-text-field',
        cols: 9,
      },
      {
        text: 'Devolução',
        value: 'DTDEVOLUCAO',
        type: 'text',
        tag: 'TkDate',
        cols: 3,
        required: false,
        showOnList: true,
      },
    ];
  };

  private confirmationDialog = {
    isVisible: false,
    message: '',
    icon: '',
  };

  private visualizer = {
    show: false,
  };

  private controleEntregaEPI = {
    show: false,
    row: {},
  };
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.view.title);
  }

  private mounted() {

  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('periodoDemonstrativoAtual')
  private onChangePeriodo(newPeriodo: Periodo) {
    this.grid.dataSource.filters.NRPERIODOAPURACAO = newPeriodo.NRPERIODOAPURACAO;
    this.reloadGridData();
  }

  @Watch('estruturaGerencialAtual')
  private onChangeEstrutura(newEstrutura: any) {
    this.grid.dataSource.filters.NRESTRUTURAM = newEstrutura.NRESTRUTURAM;
    this.reloadGridData();
  }
  // #endregion

  // #region [ METHODS ]
  private reloadGridData() {
    return this.grid.triggers.reload++;
  }

  private controleEntregaEPIPopup(row: any) {
    this.controleEntregaEPI.row = row;
    // Tratativa especifica para NRVINCULOM
    if (this.controleEntregaEPI.row && (this.controleEntregaEPI.row as any).NRVINCULOM) {
      (this.controleEntregaEPI.row as any).NRVINCULOM = parseInt((this.controleEntregaEPI.row as any).NRVINCULOM, 10);
      (this.controleEntregaEPI.row as any).__is_new = false;
    }

    this.controleEntregaEPI.show = true;
  }

  private async removeEntregaEPIPopup(row) {
    await DialogUtils.show('Exluir histórico de EPI', 'Deseja realmente excluir o histórico de EPI?');
    const success = await ControleEntregaEPIController.deleteHistoricoEpi(row);
    if (success) {
      this.reloadGridData();
    }
  }

  // #endregion
}

export default ControleEntregaEPI;